<template>
  <div class="mx-auto col-md-10">
    <el-divider class="divider-green"></el-divider>
    <el-card class="box-card" shadow="always">
      <div class="row document-upload">
        <div class="col-sm-6">
          <h3>Required Documents</h3>
          <div class="pt-20">

           <div v-if="isOrderRatified" class="uploaded-documents">
              <div :class="ratificationDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="ratificationDocumentStatus ? 'el-icon-check' : 'el-icon-close'
                "></i>
                <span> Ratification  </span>
              </div>
            </div>
            
            <div class="uploaded-documents">
              <div :class="authorizedDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="authorizedDocumentStatus ? 'el-icon-check' : 'el-icon-close'
                "></i>
                <span> Transaction Authorization </span>
              </div>
            </div>
            <div class="uploaded-documents">
              <div :class="receivingReportDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="receivingReportDocumentStatus
                  ? 'el-icon-check'
                  : 'el-icon-close'
                "></i>
                <span> Receiving Report </span>
              </div>
            </div>
            <div class="uploaded-documents">
              <div :class="returnReplacementDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="returnReplacementDocumentStatus
                  ? 'el-icon-check'
                  : 'el-icon-close'
                "></i>
                <span> Return / Replacement {{ isMonetaryOrder ? '(Not Required for MONETARY)' : '' }} </span>
              </div>
            </div>
            <div class="uploaded-documents">
              <div :class="invoicedDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="invoicedDocumentStatus ? 'el-icon-check' : 'el-icon-close'
                "></i>
                <span> Invoice </span>
              </div>
            </div>
           
            <div class="uploaded-documents">
              <div :class="transactionCompletedDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="transactionCompletedDocumentStatus
                  ? 'el-icon-check'
                  : 'el-icon-close'
                "></i>
                <span> Transaction Completion </span>
              </div>
            </div>
            
           <div class="uploaded-documents">
              <div :class="financialValidationDocumentStatus
                  ? 'uploaded-document uploaded title-case'
                  : 'uploaded-document not-uploaded title-case'
                ">
                <i :class="financialValidationDocumentStatus ? 'el-icon-check' : 'el-icon-close'
                "></i>
                <span> Financial Validation
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">

          <div class="pt-20">
            <label for="">Document Type</label>
            <treeselect :append-to-body="true" :multiple="true" @input="updateDocumentType" :normalizer="normalizer" v-model="values"
              :clearable="true" :zIndex="1" ::clear-on-select="true" 
              :options="documentsData" />
          </div>

          <div class="pt-20">
            <label for="">Remarks</label>
            <base-input type="textarea" :rows="2" placeholder="Remarks..." v-model="form.remark">
            </base-input>
          </div>
        

          <div v-if="isTransactionCompletionSelected" class="pt-20">
            <label for="">Transaction Completion Amount</label>
            <base-input type="number" :rows="2" placeholder="Amount" v-model="transactionAmount">
            </base-input>
          </div>
          <div class="pt-20">
            <input type="file" id="file" ref="file"
              accept=".pdf,.png,.jpg,.jpeg,.docx,.doc,.csv,.xls,.xlsx,.txt,.pptx,.ppt,.msg"
              @change="handleFileUpload()" />
            <div class="el-upload__tip" slot="tip">
              <strong>
                <small>*.pdf/.png/.jpg/.jpeg/.docx/.doc/.csv/.xls/.xlsx/.txt/.pptx/.ppt/.msg
                  Document files with a size less than 10MB</small>
              </strong>
            </div>
          </div>
          <el-divider class="divider-green"></el-divider>
          <div>
            <base-button :disabled="savingDocument || remainingAmount" type="primary" @click="submitDocument()">{{ savingDocument ?
                "Saving..." : "Add" }}
            </base-button>
          </div>
        </div>
      </div>

      <el-radio-group fill="#10b45a" v-model="selectedDocumentType">
        <el-radio-button label="U.S."></el-radio-button>
        <el-radio-button label="Partner Nation"></el-radio-button>
      </el-radio-group>
      <el-divider class="divider-green"></el-divider>
      <div class="row">
        <div class="col-sm-12">
          <el-table
            :data="selectedDocumentType == 'U.S.' ? isUSDocument : documents.filter((e) => e.fileTypeNames.includes('PARTNER NATION'))"
            empty-text="No Order documents found" border fit class="document-table">

            <el-table-column width="60" type="index"> </el-table-column>
            <el-table-column label="Operations" min-width="190">
              <template slot-scope="{ row, index }">
                <el-tooltip v-show="!row.editMode" class="item" effect="dark" content="Download Document"
                  placement="top-start">
                  <router-link :to="`/api/orderfiles/${row.id}`" class="btn-sm btn-download add-more-right-margin"
                    target="_blank">
                    <i class="el-icon-download"></i>
                  </router-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="row.editMode ? 'Save Document' : 'Edit Document'" placement="top-start">
                  <el-button size="mini" v-show="!isReadOnly"
                    :disabled="isReadOnly || (isEditing && editingRowId !== row.id) || (row.fileTypeNames.includes('TRANSACTION COMPLETION') && isMonetaryOrder )" :class="row.editMode ? 'btn-primary' : 'btn-secondary'
                " :icon="row.editMode ? 'el-icon-check' : 'el-icon-edit'"
                    @click="handleEdit(row, index)"></el-button>
                </el-tooltip>
                <el-tooltip v-show="row.editMode" class="item" effect="dark" content="Cancel Edit"
                  placement="top-start">
                  <el-button size="mini" v-show="!isReadOnly" :disabled="isReadOnly" class="btn-secondary editing"
                    @click="handleCancel(row, index)">X</el-button>
                </el-tooltip>
                <el-tooltip class="item" v-show="!row.editMode" effect="dark" content="Delete Document"
                  placement="top-start">
                  <el-button v-show="!isReadOnly" :disabled="(isReadOnly && !canManageRatification) || (isEditing && editingRowId !== row.id) || (row.fileTypeNames.includes('TRANSACTION COMPLETION') && isMonetaryOrder ) || (row.fileTypeNames.includes('RATIFICATION') && !canManageRatification) || isCompletedOrCancelledOrder"
                    size="mini" class="btn-secondary editing" icon="el-icon-delete"
                    @click="handleDelete(row, index)"></el-button>
                </el-tooltip>

              </template>

            </el-table-column>
            <el-table-column min-width="280" prop="fileTypeNames" label="Document Type">
              <editable-cell :show-input="row.editMode && row.canChangeDocumentType" slot-scope="{ row }"
                editable-component="el-select" close-event="change" multiple v-model="row.fileTypeNames"
                @change="listenUpdate(row)">

                <span slot="content">
                  {{ row.fileTypeNames.join(", ") }}
                </span>

                <template slot="edit-component-slot">
                  <el-option v-for="document in documentsData" class="select-primary" :label="document.name"
                    :value="document.name" :key="document.id">
                  </el-option>
                </template>

              </editable-cell>
               <modal style="z-index: 100;" :show="ratificationDeleteModal" v-bind:middle="true" :showClose="false" 
                modal-id="ratificationDeleteModal" headerClasses="justify-content-center">
                <div class="container">
                  <div class="text-center mb-2">
                    <div style="font-size: 48px; color: #ff6b35; border: 3px solid #ff6b35; border-radius: 50%; padding: 15px; width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; margin: 0 auto; background-color: white; font-weight: bold;">!</div>
                  </div>
                  <h4 class="text-center mb-3" style="font-weight: 600; color: #333;">Delete File</h4>
                  <p class="text-center mb-3">Please provide a brief justification for deleting this document.</p>
                  <div class="row">
                    <div class="col-12">
                      <textarea 
                        class="form-control"
                        rows="4" 
                        placeholder="" 
                        v-model="deleteReason"
                        style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; resize: vertical; font-family: inherit; font-size: 14px;">
                      </textarea>
                    </div>
                  </div>
                </div>
                <template slot="footer">
                  <div style="width: 86%; align-items: center; margin: 0 auto;" class="container alert_footer d-flex justify-content-between">
                    <base-button
                      type="danger"
                      @click.native="() =>{ ratificationDeleteModal = false; deleteReason=''}"
                      class="alert_footer_button btn_extra_small btn_info"
                    >
                      Cancel
                    </base-button>
                    <base-button 
                      type="primary"
                      @click.native="submitDeleteRatification()"
                      class="alert_footer_button btn_extra_small btn_info ratification-delete-btn"
                    >
                      Yes, delete it!
                    </base-button>
                  </div>
                </template>
              </modal>
              <modal :show="isModalOpen" v-bind:middle="true" :showClose="false" style="z-index: 10000"
                modal-id="PNDocumentsModal" headerClasses="justify-content-center" type="notice">
                <h4 slot="header" class="title title-up">Note</h4>
                <hr />
                <div class="container">
                  <div class="row">
                    {{ modalMessage }}
                  </div>
                </div>
                <template slot="footer">

                  <div class="container alert_footer">
                    <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-2"
                      @click.native="() => isModalOpen = false">
                      Dismiss
                    </base-button>

                  </div>
                </template>
              </modal>

              <modal :show="amountModal" v-bind:middle="true" :showClose="false" style="z-index: 10000;"
                modal-id="PNDocumentsModal" headerClasses="justify-content-center" type="notice">
                <h4 slot="header" class="title title-up">Transaction Completion Amount</h4>
                <hr />
                <div class="container align-center">
                  <div class="row">
                    <div>
            <label for="">Transaction Completion Amount</label>
            <base-input type="number"  placeholder="Amount" v-model="transactionAmount">
            </base-input>
          </div>
                  </div>
                </div>
                <template slot="footer">

                  <div class="container align-center alert_footer">
                    <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-2"
                      @click.native="() =>{ amountModal = false; transactionAmount=null}">
                      Cancel
                    </base-button>
                    <base-button type="primary" class="alert_footer_button btn_extra_small btn_info mr-2"
                      @click.native="submitAmountModal()">
                      Ok
                    </base-button>

                  </div>
                </template>
              </modal>

            </el-table-column>

            <el-table-column min-width="190" prop="remark" label="Remark">
              <editable-cell :show-input="row.editMode" slot-scope="{ row }" v-model="row.remark">
                <span slot="content">{{
                row.remark != "null" ? row.remark : ""
              }}</span>
              </editable-cell>
            </el-table-column>


            <el-table-column min-width="190" prop="fileName" label="File Name"></el-table-column>
            <el-table-column min-width="190" prop="fileSizeInBytes" label="File Size(byte)"></el-table-column>
            <el-table-column min-width="190" prop="createBy" label="Uploaded By"></el-table-column>
            <el-table-column min-width="190" label="Uploaded Date">
              <template slot-scope="scope">{{ formatDate(scope.row.createDate) }}
              </template></el-table-column>


          </el-table>
        </div>
      </div>

    </el-card>
   


  </div>
</template>

<script>
import moment from "moment";
import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
  RadioGroup,
  RadioButton
} from "element-ui";
import { BaseButton, EditableCell } from "@/components";
import { mapActions, mapGetters } from "vuex";
import Utility from "@/mixins/utility/utility";
import LoadingAlertMixin from "@/mixins/docLoadingAlert";
import swal from "sweetalert2";
import { Modal } from "@/components/index";
import Treeselect from "@riophae/vue-treeselect";
import Util from "@/util/util";
import { EventBus } from "@/event-bus.js";

export default {
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [Utility, LoadingAlertMixin],
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    EditableCell,
    Treeselect,
    Modal
  },
  filters: {
    upper(str) {
      str = str.toLowerCase().split(" ");

      let final = [];

      for (let word of str) {
        final.push(word.charAt(0).toUpperCase() + word.slice(1));
      }

      return final.join(" ");
    },
  },
  watch: {
    activeTab(newTab, oldTab) {
      if (newTab == "Documents") {
        this.loadDocumentData();
      }
    },
    "$route.params.id": function (id) {
      if (id != 0) {
        this.getDocuments(id);
      }
    },
    values(newVal, oldVal) {
      this.form.documentType = newVal
    }
  },
  created() {

    EventBus.$on('clicked-from', async (value) => {
  this.values = [];
  await this.$store.dispatch("documents/getDocumentTypes");

  let documentTypeName;
  
  switch (value) {
    case "INVOICE":
      documentTypeName = "INVOICE";
      break;
    case "BILL":
      documentTypeName = "BILL";
      break;
    case "RATIFICATION":
      documentTypeName = "RATIFICATION";
      break;
    default:
      documentTypeName = value;
      break;
  }

  let getItem = this.documentTypes.filter(item => item.name === documentTypeName);
  
  if (getItem.length) {
    this.values.push(getItem[0].id);
  }
});
  },

  data() {
    return {
      editing: null,
      isEditing: false,
      editingRowId: null,
      editingRow: null,
      fileTypeIds: [],
      values: [],
      isModalOpen: false,
      selectedDocumentType: 'U.S.',
      modalMessage: "",
      currentVal: null,
      transactionAmount: null,
      amountModal: false,
      isUpdating: false,
      tableFields: [
        "documentType",
        "remark",
        "fileName",
        "fileSize",
        "uploadedBy",
        "uploadedDate",
      ],
      savingDocument: false,
      ratificationDeleteModal: false,
      deleteReason: '',
      selectedRow: null,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  computed: {
    ...mapGetters({
      orderMetadata: "orderMetadata/orderMetadata",
      documentTypes: "documents/documentTypes",
      documents: "documents/getDocuments",
      form: "documents/form",
      uploading: "documents/uploadingStatus",
      orderIdFromPreOrderDetail: "preOrderDetail/preOrder",
      activeTab: "tab/activeTab",
      preOrder: "preOrderDetail/preOrder",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isOrderRatified: "preOrderDetail/isOrderRatified",
      isBuyingTransaction: "preOrderDetail/isBuyingTransaction",
      authorizedRatifierRatificationStatus: "authorizedRatifier/authorizedRatifierAuthorizeStatus",
      authorizedRequestorAuthorizeStatus: "authorizedRequestor/authorizedRequestorAuthorizeStatus",
      authorizedAcceptorAuthorizeStatus: "authorizedAcceptor/authorizedAcceptorAuthorizeStatus",
      inspectedReceivedByStatus: "inspectedReceivedBy/inspectedReceivedByStatus",
      returnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgmentStatus",
      authorizedRatifier: "authorizedRatifier/authorizedRatifier",
      authorizedAcceptor: "authorizedAcceptor/authorizedAcceptor", // Authorize Tab
      authorizedRequestor: "authorizedRequestor/authorizedRequestor", // Authorize Tab
      inspectedReceivedBy: "inspectedReceivedBy/inspectedReceivedBy", // Receipt Tab
      supplyOfficial: "supplyOfficial/supplyOfficial", // Invoice Tab
      financialRepresentative: "financialRepresentative/financialRepresentative", // Bill Tab
      disbursingCollectionInfo:
        "disbursingCollectionInformation/disbursingCollectionInfo",
      disbursingCollections:
        "disbursingCollectionInformation/disbursingCollections",
        disbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/disbursingCollectionOutstandingBalance",
      disbursingCollectionInformationStatus:
        "disbursingCollectionInformation/disbursingCollectionInformationStatus",
      returnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgment",
      user: "authentication/getUser",
      isLoggedIn: "authentication/isLoggedIn",
      isOUSD: 'authentication/isOUSD',
      isViewOnly: 'authentication/isViewOnly',
      orderStatus: "orderMetadata/orderStatus",
      isSuperAdmin: "authentication/isSuperAdmin",
      isLogistics: "authentication/isLogistics",
      isFinance: "authentication/isFinance",
      isSponsor: "authentication/isSponsor",
      isTraining: "authentication/isTraining",
      isPartnerAccount: "authentication/isPartnerAccount",

    }),
      isCompletedOrCancelledOrder() {
      return (this.orderMetadata.orderStatus == "COMPLETED" || this.orderMetadata.orderStatus == "CANCELLED");
    },
    canManageRatification() {
      return this.isSuperAdmin 
    },
    remainingAmount(){
      if(this.isTransactionCompletionSelected || this.isUpdating){
      return  this.disbursingCollectionOutstandingBalance - this.transactionAmount == 0 ? false : true
      }else{
        return false
      }
    },
    ratificationDocumentID(){
      if (!this.documentTypes || this.documentTypes.length === 0) return null;
      const doc = this.documentTypes.find((e)=> e.name === "RATIFICATION");
      return doc ? doc.id : null;
    },
    partnerNationDocumentID(){
      if (!this.documentTypes || this.documentTypes.length === 0) return null;
      const doc = this.documentTypes.find((e)=> e.name === "PARTNER NATION");
      return doc ? doc.id : null;
    },
    isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    ratificationDocuments() {
      if (!this.documentTypes) return [];
      return this.documentTypes.filter((e)=> e.name != 'TRANSACTION COMPLETION' && e.name != 'RATIFICATION')
    },
    transactionCompletionDocuments(){
      if (!this.documentTypes) return [];
      return this.documentTypes.filter((e)=> e.name != 'TRANSACTION COMPLETION' && e.name !='FINANCIAL VALIDATION')
    },
    isUSDocument() {
      const filteredObjects = this.filterByOnlyPartnerNation(this.documents, 'PARTNER NATION')
      return filteredObjects
    },
    isTransactionCompletionSelected(){
      if(this.documentTypes && this.documentTypes.length > 0 ){
      const value =  this.documentTypes.find((e) => e.name === 'TRANSACTION COMPLETION')
      const res = this.values.find((e) => e == value.id)
      return res
      }
    },
    ratificationDocumentStatus() {
      if (
        this.uploadedDocumentsStatus &&
        this.uploadedDocumentsStatus.includes("RATIFICATION")
      ) {
        return true;
      }

      return this.uploadedDocumentsStatus && this.authorizedRatifierRatificationStatus
        ? true
        : false;
    },
    documentsData() {
      return this.isPartnerAccount ? (this.canManageRatification ? this.documentTypes.filter(e => e.name != 'TRANSACTION COMPLETION') : this.ratificationDocuments) : this.transactionCompletionDocuments
    },
    authorizedDocumentStatus() {
      if (
        this.uploadedDocumentsStatus &&
        this.uploadedDocumentsStatus.includes("TRANSACTION AUTHORIZATION")
      ) {
        return true;
      }

      return this.authorizedAcceptor &&
        this.authorizedAcceptor.acceptorSignature &&
        this.authorizedAcceptor.acceptorSignature.signatureId != 0 &&
        this.authorizedAcceptor.acceptorDateSigned &&
        this.authorizedRequestor &&
        this.authorizedRequestor.requestorSignature &&
        this.authorizedRequestor.requestorSignature.signatureId != 0 &&
        this.authorizedRequestor.requestorDateSigned
        ? true
        : false;
    },

    receivingReportDocumentStatus() {
      /*  if (this.isMonetaryOrder) {
        return true;
      } */
      if (this.inspectedReceivedBy.selectedIsPartial && !this.isLegacyOrder) {

        return false;
      }

      if (
        this.uploadedDocumentsStatus &&
        this.uploadedDocumentsStatus.includes("RECEIVING REPORT")
      ) {
        return true;
      }

      return this.uploadedDocumentsStatus && this.inspectedReceivedByStatus
        ? true
        : false;
    },
    returnReplacementDocumentStatus() {
      const hasDocument = this.uploadedDocumentsStatus &&
        this.uploadedDocumentsStatus.includes("RETURN REPLACEMENT");

      const hasSignature = this.returnReplacementReceiptAcknowledgment &&
        !Util.isNullOrEmpty(this.returnReplacementReceiptAcknowledgment.returnSignature) &&
        this.returnReplacementReceiptAcknowledgment.returnSignature.signatureId != 0;

      // 1. New order (no document, no signature) -> always false
      if (!hasDocument && !hasSignature) {
        // Exception: Monetary orders are always true even if new
        if (this.isMonetaryOrder) {
          return true;
        }
        return false;
      }

      // 2. Monetary order -> always true
      if (this.isMonetaryOrder) {
        return true;
      }

      if (
        new Date(this.orderMetadata.createDate) <
        new Date("February 20, 2021 12:00:00")
      ) {
        return true;
      }

      return hasDocument || hasSignature;
    },
    invoicedDocumentStatus() {
      if (this.uploadedDocumentsStatus && this.uploadedDocumentsStatus.includes("INVOICE")) {
        return true;
      }

      return !Util.isNullOrEmpty(this.supplyOfficial.supplierSignature) && this.supplyOfficial.supplierSignature.signatureId != 0
        ? true
        : false;
    },
    financialValidationDocumentStatus() {
      if ((this.uploadedDocumentsStatus && this.uploadedDocumentsStatus.includes("FINANCIAL VALIDATION"))) {
        return true;
      }

      if (!Util.isNullOrEmpty(this.financialRepresentative.financeSignature) && this.financialRepresentative.financeSignature.signatureId != 0) {
        return true
      } 
      
      return false;
    },
    transactionCompletedDocumentStatus() {
      if (this.uploadedDocumentsStatus && (this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETED") || this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETION"))) {
        return true;
      }

      if (this.isRikOrEveOrder) {
        if (this.uploadedDocumentsStatus && (this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETED") || this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETION"))) {
          return true;
        } else {
          return false;
        }
      }

      return this.disbursingCollectionInformationStatus;
    },
    ratificationDocumentStatus(){
      if (this.uploadedDocumentsStatus && this.uploadedDocumentsStatus.includes("RATIFICATION")) {
        return true;
      }else{
        return false
      }
    },
    isAuthorizationCompleted() {
      return (
        this.authorizedRequestorAuthorizeStatus &&
        this.authorizedAcceptorAuthorizeStatus
      );
    },
    requiredDocuments() {
      if (this.documentTypes != null) {
        if (this.documentTypes.length > 0) {
          let docs = this.documentTypes.filter(function (doc) {
            return doc.name != "OTHER";
          });

          return [...new Set(docs.map((doc) => doc.name))];
        }
      }
    },
    transactionAuthorizationSatisfiedBy() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("TRANSACTION AUTHORIZATION")
        ).length > 0
          ? true
          : false;

      if (
        isDocumentUploaded &&
        this.authorizedAcceptor.acceptorSignature &&
        this.authorizedRequestor.requestorSignature
      ) {
        return;
      }

      if (isDocumentUploaded) {
        return " - Satisfied by Document";
      }

      if (
        this.authorizedAcceptor.acceptorSignature &&
        this.authorizedRequestor.requestorSignature
      ) {
        return " - Satisfied by Signature";
      }
      return null;
    },
    receivingReportSatisfiedBy() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("RECEIVING REPORT")
        ).length > 0
          ? true
          : false;

      if (
        isDocumentUploaded &&
        this.inspectedReceivedBy.receiverSignature &&
        this.returnReplacementReceiptAcknowledgment.returnSignature
      ) {
        return;
      }

      if (isDocumentUploaded) {
        return " - Satisfied by Document";
      }

      if (this.isMonetaryOrder) {
        if (this.inspectedReceivedBy.receiverSignature) {
          return " - Satisfied by Signature";
        }
      } else {
        if (
          this.inspectedReceivedBy.receiverSignature &&
          this.returnReplacementReceiptAcknowledgment.returnSignature
        ) {
          return " - Satisfied by Signature";
        }
      }
      return null;
    },
    invoicedSatisfiedBy() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("INVOICE")
        ).length > 0
          ? true
          : false;

      if (isDocumentUploaded && this.supplyOfficial.supplierSignature) {
        return;
      }

      if (isDocumentUploaded) {
        return " - Satisfied by Document";
      }

      if (this.supplyOfficial.supplierSignature) {
        return " - Satisfied by Signature";
      }
    },
    billedSatisfiedBy() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("BILL")
        ).length > 0
          ? true
          : false;

      if (
        isDocumentUploaded &&
        this.financialRepresentative.financeSignature
      ) {
        return;
      }

      if (isDocumentUploaded) {
        return " - Satisfied by Document";
      }

      if (this.financialRepresentative.financeSignature) {
        return " - Satisfied by Signature";
      }
    },
    transactionCompletedSatisfiedBy() {
      let isDocumentUploaded =
        this.documents.filter(
          (document) =>
            document.fileTypeNames.includes("TRANSACTION COMPLETED") ||
            document.fileTypeNames.includes("TRANSACTION COMPLETION")
        ).length > 0
          ? true
          : false;

      if (
        isDocumentUploaded &&
        this.isMonetaryOrder && this.disbursingCollections && this.disbursingCollections.length > 0
      ) {
        return;
      }

      if (isDocumentUploaded) {
        return " - Satisfied by Document";
      }

      if (
        this.isMonetaryOrder && this.disbursingCollections && this.disbursingCollections.length > 0
      ) {
        return " - Satisfied by Disbursing Collection Information";
      }
    },
    isReceiptCompleted() {
      return (
        this.inspectedReceivedByStatus &&
        this.returnReplacementReceiptAcknowledgmentStatus
      );
    },
    uploadedDocumentsStatus() {
      if (this.documents && this.documents.length > 0) {
        let uploadedDocuments = [];

        this.documents.forEach((doc) =>
          doc.fileTypeNames.forEach((fileName) =>
            uploadedDocuments.push(fileName)
          )
        );

        return [...new Set(uploadedDocuments)];
      } else {
        return [];
      }
    },
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    orderId() {
      if (this.isOrderIdAvailable && this.orderIdFromRoute !== 0) {
        return this.orderIdFromRoute;
      } else {
        return this.orderIdFromPreOrderDetail.orderId;
      }
    },
    isOrderIdAvailable() {
      return (
        this.orderIdFromRoute != 0 ||
        (this.orderIdFromRoute != 0 &&
          this.orderIdFromPreOrderDetail &&
          this.orderIdFromPreOrderDetail.orderId != 0)
      );
    },
    isPartialReturnReplacement() {
      return this.returnReplacementReceiptAcknowledgment.isPartialReturn;
    }
  },

  methods: {
    ...mapActions({
      getDocumentTypes: "documents/getDocumentTypes",
      updateDocumentType: "documents/updateDocumentType",
      getDocuments: "documents/getDocuments",
      clearNewDocumentData: "documents/clearNewDocumentData",
      updateDocumentData: "documents/updateDocument",
      deleteDocument: "documents/deleteDocument",
      deleteRatificationDocument: "orders/deleteRatificationDocument",
      downloadDocument: "documents/downloadDocument",
      disabledOtherEdits: "documents/disabledOtherEdits",
      getAuthorizedRatifierRatificationStatus: "authorizedRatifier/getAuthorizedRatifierAuthorizeStatus",
      getAuthorizedRequestorAuthorizeStatus: "authorizedRequestor/getAuthorizedRequestorAuthorizeStatus",
      getAuthorizedAcceptorAuthorizeStatus: "authorizedAcceptor/getAuthorizedAcceptorAuthorizeStatus",
      getRatificationStatus: "authorizedRatifier/getAuthorizedRatifierAuthorizeStatus",
      getFinancialRepresentativeStatus: "financialRepresentative/getFinancialRepresentativeStatus",
      getInspectedReceivedByStatus:
        "inspectedReceivedBy/getInspectedReceivedByStatus",
      getSupplyOfficialStatus: "supplyOfficial/getSupplyOfficialStatus",
      loadDisbursingCollectionInformation:
        "disbursingCollectionInformation/loadDisbursingCollectionInformation",
      loadAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/loadAllDisbursingInfoByOrderId",
      getDisbursingCollectionInformationStatus:
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
      getReturnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentStatus",
      getAuthorizedRatifier: "authorizedRatifier/getAuthorizedRatifier",
      loadAuthorizedRequestor: "authorizedRequestor/getAuthorizedRequestor",
      loadAuthorizedAcceptor: "authorizedAcceptor/getAuthorizedAcceptor",
      getInspectedReceivedBy: "inspectedReceivedBy/getInspectedReceivedBy",
      loadFinancialRepresentative: "financialRepresentative/getFinancialRepresentative",
      loadSupplyOfficial: "supplyOfficial/getSupplyOfficial",
      loadReturnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgment",
      setAcceptorSignatureUpdated: "orders/setAcceptorSignatureUpdated",
      setRequestorSignatureUpdated: "orders/setRequestorSignatureUpdated",
    }),
    closeModal() {
      this.isModalOpen = false
    },
    filterByOnlyPartnerNation(array, value) {
      return array.filter(obj => {
        const fileType = obj.fileTypeNames;
        if (Array.isArray(fileType) && fileType.length === 1 && fileType[0] === value) {
          return false
        }
        return true
      })
    },
    listenUpdate(row) {
      const cVal = this.currentVal
      const missingVal = cVal.filter(function (x) {
        return !row.fileTypeNames.includes(x);
      })
      if(!cVal.includes('TRANSACTION COMPLETION') &&  row.fileTypeNames.includes('TRANSACTION COMPLETION')){
        this.amountModal = true
        this.isUpdating = true
      }

      if (missingVal.includes('PARTNER NATION')) {
        this.modalMessage = "This document will only be available in the U.S. tab as it no longer has Partner Nation reference. Save or Cancel this change in the Operations column."
        this.selectedDocumentType = 'U.S.'
        this.isModalOpen = true
      }


      if (row.fileTypeNames.includes("PARTNER NATION") && row.fileTypeNames.length == 1) {
        this.modalMessage = "This document will only be available in the Partner Nation Tab as it only has Partner Nation reference. Save or Cancel this change in the Operations column."
        this.selectedDocumentType = 'Partner Nation'
        this.isModalOpen = true
      }
    },

    loadDocumentData() {
      this.getDocumentTypes();

      // Fetch Documents if Order Id is available
      if (this.isOrderIdAvailable) {
        this.getAuthorizedRequestorAuthorizeStatus(this.orderId);
        this.getAuthorizedAcceptorAuthorizeStatus(this.orderId);
        this.getFinancialRepresentativeStatus(this.orderId);
        this.getInspectedReceivedByStatus(this.orderId);
        this.getSupplyOfficialStatus(this.orderId);
        this.getDisbursingCollectionInformationStatus(this.orderId);
        this.loadDisbursingCollectionInformation(this.orderId);
        this.getReturnReplacementReceiptAcknowledgmentStatus(this.orderId);
        this.loadAllDisbursingInfoByOrderId(this.orderId);
        this.getDocuments(this.orderId);
      } else {
      }
    },
    formatDate(date) {
      return Util.formatDateWithLocalTimezone(date);
    },
    handleEdit(row, index) {
      // Backend allows: "Ousd,Logistics,Finance,Training,Sponsor"
      if(row.fileTypeNames.includes("RATIFICATION") && !this.canManageRatification){
  this.editingRow = row
  new swal({
        title: "Edit Ratification File",
        html: `Ratification file cannot be edited.Contact your Sponsor for assistance.`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton:false,
        cancelButtonColor: "#10b45a",
        cancelButtonText: "ok",
        reverseButtons: true,
      });
}else{
      if (row.editMode) {
        // Row Updating Section
        row.editMode = false;
        this.$loaderApp.addRequest();
        if(!this.remainingAmount){
        this.updateDocumentData(row).then(async () => {
          this.$toast.success("Updates Saved")
          this.editingRowId = null;
          this.isEditing = false;
          await this.loadAuthorizedRequestor(this.orderId);
          await this.loadAuthorizedAcceptor(this.orderId);
          await this.getInspectedReceivedBy(this.orderId);
          await this.loadFinancialRepresentative(this.orderId);

          await this.loadSupplyOfficial(this.orderId);
          await this.loadReturnReplacementReceiptAcknowledgment(this.orderId);
          this.$loaderApp.completeRequest();
          EventBus.$emit('doc-type-change');
        }).catch((error) => {
          this.editingRowId = null;
          this.isEditing = false;
          this.$loaderApp.completeRequest();
        });
        this.isModalOpen = false
        this.amountModal = false
        this.isUpdating = false
        this.transactionAmount = null
        this.getDocuments(this.orderId);
      }else{
      this.$toast.error("Transaction Completion must equal Total Outstanding Balance");
      this.$refs.file.value = null;
      this.editingRowId = null;
      this.isEditing = false;
      this.getDocuments(this.orderId);
      this.$loaderApp.completeRequest();
    }
      } else {
        // Edit Section
        this.currentVal = row.fileTypeNames
        this.disabledOtherEdits(row.id);
        this.isEditing = true;
        this.editingRowId = row.id;
        row.editMode = true;
        row.canChangeDocumentType = true;
      }
    }
    },
    handleCancel(row, index) {
      row.editMode = false;
      this.isEditing = false;
      this.editingRowId = null;
      this.isModalOpen = false
      this.getDocuments(this.orderId);
    },
    submitAmountModal(){
      
      this.amountModal = false
      if(this.remainingAmount)
      this.$toast.error("Transaction Completion must equal Total Outstanding Balance");
      this.isEditing = false;
      this.editingRowId = null;
    },
   async  submitDeleteRatification(){
      if(this.deleteReason == ''){
        this.$toast.error("Please provide a reason to delete the document")
        return
      }else{
      
        try {
        this.$loaderApp.addRequest();

          // Delete the file with deletion reason
          let response;
          if (this.selectedRow && this.selectedRow.id) {
            response = await this.deleteDocument({ 
              row: this.selectedRow, 
              deletionReason: this.deleteReason 
            });
          }
          
          const deletedRow = this.selectedRow;
          this.ratificationDeleteModal = false;
          this.deleteReason = '';
          this.selectedRow = null;
          
          // Refresh all signature data and statuses (same as production delete path)
          await this.loadAuthorizedRequestor(this.orderId);
          await this.loadAuthorizedAcceptor(this.orderId);
          await this.getInspectedReceivedBy(this.orderId);
          await this.loadFinancialRepresentative(this.orderId);
          await this.loadSupplyOfficial(this.orderId);
          await this.getAuthorizedRatifier(this.orderId);

          // statuses
          await this.getAuthorizedRequestorAuthorizeStatus(this.orderId);
          await this.getRatificationStatus(this.orderId);
          await this.getAuthorizedAcceptorAuthorizeStatus(this.orderId);
          await this.getInspectedReceivedByStatus(this.orderId);
          await this.getFinancialRepresentativeStatus(this.orderId);
          await this.getSupplyOfficialStatus(this.orderId);
          await this.getReturnReplacementReceiptAcknowledgmentStatus(this.orderId);
          await this.loadReturnReplacementReceiptAcknowledgment(this.orderId);

          // Show the backend response message (e.g. "Please replace the document...")
          if (response && response.data) {
            await new swal({
              title: "",
              html: `${response.data}`,
              icon: "info",
              showCancelButton: false,
              confirmButtonColor: "#10b45a",
              confirmButtonText: "Okay",
            });
          }

          if (deletedRow && (
            deletedRow.fileTypeNames.includes("TRANSACTION COMPLETED") ||
            deletedRow.fileTypeNames.includes("TRANSACTION COMPLETION")
          )) {
            this.getDisbursingCollectionInformationStatus(this.orderId);
          }

          this.$toast.success("Your file has been deleted.");
          this.$loaderApp.completeRequest();
          
        } catch (error) {
          this.$toast.error("Failed to delete file");
          this.$loaderApp.completeRequest();
          console.error(error);
        }
      }
    },
    canEditFile(row) {
      switch (row.fileTypeNames[0]) {
        case "TRANSACTION AUTHORIZATION":
          return this.authorizedAcceptor.acceptorSignature &&
            this.authorizedRequestor.requestorSignature
            ? true
            : false;
          break;
        case "RECEIVING REPORT":
          return this.inspectedReceivedBy.receiverSignature &&
            this.returnReplacementReceiptAcknowledgment.returnSignature
            ? true
            : false;
          break;
        case "INVOICE":
          return this.supplyOfficial.supplierSignature ? true : false;
          break;
        case "BILL":
          return this.financialRepresentative.financeSignature ? true : false;
          break;
        default:
          break;
      }
    },
    async handleDownload(row, index) {
      this.showLoadingSweetAlert(
        "Your document is downloading.<br><br>Please wait..."
      );
      try {
        let response = await this.downloadDocument(row);
        this.closeLoadingAlert();
        this.showAlertDialog("Success", "Download completed successfully!", "success");
      } catch (error) {
        this.closeLoadingAlert();
        this.showAlertDialog("Error", "Download failed. Please try again.", "error");
      }
    },
    async handleDelete(row, index) {
      // Check if user has permission to delete ratification files
      // Backend allows: "AGATRS Team" only (super admin)
      // TODO: Reconsider deletion justification requirements based on each role —
      // determine which roles can delete without a reason vs. which roles require a reason.
      // Currently all super admin deletes require justification (September 2025 requirement).
      // const noJustificationRequired = ["TRANSACTION AUTHORIZATION"];
      // const skipJustification = row.fileTypeNames.some(t => noJustificationRequired.includes(t));

      if(this.isSuperAdmin){
        this.selectedRow = row;
        this.ratificationDeleteModal = true;
      }
      else if(row.fileTypeNames.includes("RATIFICATION") && !this.canManageRatification){
        this.editingRow = row;
        new swal({
          title: "Delete Ratification File",
          html: `Ratification file cannot be deleted.Contact your Sponsor for assistance.`,
          icon: "warning",
          showCancelButton: true,
          showConfirmButton:false,
          cancelButtonColor: "#10b45a",
          cancelButtonText: "ok",
          reverseButtons: true,
        });
      } else if(row.fileTypeNames.includes("RATIFICATION")) {
        // Show the ratification delete modal with reason field for ratification files
        this.selectedRow = row;
        this.ratificationDeleteModal = true;
      } else {
        // Ratification files are treated like regular files - just delete the file, keep ratification status
        let canDeletefile = true;
        const fileTypeName = row.fileTypeNames[0];
        const fileCount = this.documents.filter(
          (document) => document.fileTypeNames[0] === fileTypeName
        ).length;

        switch (fileTypeName) {
          case "TRANSACTION AUTHORIZATION":
            if (
              this.authorizedAcceptor.acceptorSignature &&
              this.authorizedRequestor.requestorSignature
            ) {
              canDeletefile = true;
              break;
            }
            if (
              fileCount < 2 &&
              !this.authorizedAcceptor.acceptorSignature &&
              !this.authorizedRequestor.requestorSignature
            ) {
              canDeletefile = false;
            }
            break;
          case "RECEIVING REPORT":
            if (
              this.inspectedReceivedBy.receiverSignature &&
              this.returnReplacementReceiptAcknowledgment.returnSignature
            ) {
              canDeletefile = true;
              break;
            }
            if (
              fileCount < 2 &&
              !this.inspectedReceivedBy.receiverSignature &&
              !this.returnReplacementReceiptAcknowledgment.returnSignature
            ) {
              canDeletefile = false;
            }
            break;
          case "INVOICE":
            if (this.supplyOfficial.supplierSignature) {
              canDeletefile = true;
              break;
            }
            if (fileCount < 2 && !this.supplyOfficial.supplierSignature) {
              canDeletefile = false;
            }
            break;
          case "BILL":
            if (this.financialRepresentative.financeSignature) {
              canDeletefile = true;
              break;
            }
            if (
              fileCount < 2 &&
              !this.financialRepresentative.financeSignature
            ) {
              canDeletefile = false;
            }
            break;

          default:
            break;
        }

        if (!canDeletefile) {
          this.$toast.error("This file cannot be deleted!!");
          return;
        }

        var result = await new swal({
          title: "Delete File",
          html: `Do you want to delete this file?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#10b45a",
          cancelButtonColor: "red",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        });
        
        if (result.value) {
          this.$loaderApp.addRequest();
          var response = await this.deleteDocument({ row: row });
          
          await this.loadAuthorizedRequestor(this.orderId);
          await this.loadAuthorizedAcceptor(this.orderId);
          await this.getInspectedReceivedBy(this.orderId);
          await this.loadFinancialRepresentative(this.orderId);
          await this.loadSupplyOfficial(this.orderId);
          await this.getAuthorizedRatifier(this.orderId);

          // statuses
          await this.getAuthorizedRequestorAuthorizeStatus(this.orderId);
          await this.getRatificationStatus(this.orderId);    
          await this.getAuthorizedAcceptorAuthorizeStatus(this.orderId);
          await this.getInspectedReceivedByStatus(this.orderId);
          await this.getFinancialRepresentativeStatus(this.orderId);
          await this.getSupplyOfficialStatus(this.orderId);
          await this.getReturnReplacementReceiptAcknowledgmentStatus(this.orderId);
          await this.loadReturnReplacementReceiptAcknowledgment(this.orderId);

          await new swal({
            title: "",
            html: `${response.data}`,
            icon: "info",
            showCancelButton: false,
            confirmButtonColor: "#10b45a",
            confirmButtonText: "Okay",
          });

          if (
            row.fileTypeNames.includes("TRANSACTION COMPLETED") ||
            row.fileTypeNames.includes("TRANSACTION COMPLETION")
          ) {
            this.getDisbursingCollectionInformationStatus(this.orderId);
          }
          this.$toast.success("Your file has been deleted.");
          this.$loaderApp.completeRequest();
        }
      }
    },
    clearAddForm() {
      this.clearNewDocumentData()
      if (this.$refs.file) {
        this.$refs.file.value = null;
      }
      this.values = []
    },

    async submitDocument() {
      let self = this;

      if (this.isOrderIdAvailable) {


        if (!this.checkFormValidations()) return;

       if(this.form.documentType.includes(this.ratificationDocumentID) && this.form.documentType.includes(this.partnerNationDocumentID)){
          this.$toast.error("A document cannot have PARTNER NATION and RATIFICATION both as document type.");
          return;
       };

       if(this.form.documentType.includes(this.ratificationDocumentID) && this.form.documentType.length > 1){
          this.$toast.error("Ratification Documents cannot be combined with other document types.");
          return;
       };

        this.showLoadingSweetAlert(
          "Your document is uploading.<br><br>This message will disappear automatically in 10 seconds."
        );

        this.savingDocument = true;

        var signature = await self.$store.dispatch(
          "documents/getFileSignature"
        );

        const formData = new FormData();

        if (self.form.documentType.length > 1) {
          self.form.documentType.forEach((document) =>
            formData.append("FileTypeIds", document)
          );
        } else {
          formData.append("FileTypeIds", self.form.documentType);
        }

        formData.append("OrderId", self.orderId);
        formData.append("Remark", self.form.remark);
        formData.append("IFile", self.form.file);
        formData.append("Signature", window.btoa(signature));

        try {
          await self.$store
            .dispatch("documents/saveDocument", formData)
          //.then(() => {
          this.savingDocument = false;
          this.closeLoadingAlert();
          this.clearAddForm();
          this.transactionAmount = null 
          // duplicate
          //self.getDisbursingCollectionInformationStatus(self.orderId);
          self.fileTypeIds = [];
          await self.getAuthorizedRequestorAuthorizeStatus(self.orderId);
          await self.getAuthorizedAcceptorAuthorizeStatus(self.orderId);
          await self.getFinancialRepresentativeStatus(self.orderId);
          await self.getInspectedReceivedByStatus(self.orderId);
          await self.getSupplyOfficialStatus(self.orderId);
          await self.getRatificationStatus(self.orderId);
          await self.getAuthorizedRatifier(self.orderId);
          await self.loadDisbursingCollectionInformation(self.orderId);
          await self.getDisbursingCollectionInformationStatus(self.orderId);
          await self.loadAuthorizedRequestor(self.orderId);
          await self.loadAuthorizedAcceptor(self.orderId);
          await self.loadSupplyOfficial(self.orderId);
          await self.loadAuthorizedRequestor(self.orderId);
          await self.loadAuthorizedAcceptor(self.orderId);
          await self.getInspectedReceivedBy(self.orderId);
          await self.loadFinancialRepresentative(self.orderId);    
        
          await self.loadSupplyOfficial(self.orderId);
          await self.getReturnReplacementReceiptAcknowledgmentStatus(self.orderId);
          await self.loadReturnReplacementReceiptAcknowledgment(self.orderId);
          
          // Success message is handled by global axios interceptor
        } catch (errorMessage) {
          this.savingDocument = false;
          this.closeLoadingAlert();
          // Only show error if upload actually failed
          if (errorMessage && errorMessage.response && errorMessage.response.status >= 400) {
            this.$toast.error("Upload failed. Please try again.");
          }
          //console.log(errorMessage); //not handelled
        }

      } else {
        this.savingDocument = false;
        this.closeLoadingAlert();
        self.$toast.error("Please fill Pre Order details first!");
      }
    },
   
    checkFormValidations() {
      if (!this.form.documentType) {
        this.$toast.error("File Type field cannot be empty!");
        return false;
      }

      if (!this.form.file) {
        this.$toast.error("Please upload a file");
        return false;
      }

      return true;
    },
    handleFileUpload() {
      if(!this.remainingAmount){
        const uploadedFile = this.$refs.file.files[0];
        if (!Util.isSupportedFile(uploadedFile.name, /(\.pdf|\.png|\.jpg|\.jpeg|\.docx|\.doc|\.csv|\.xls|\.xlsx|\.txt|\.pptx|\.ppt|\.msg)$/i)) {
          this.$toast.error("Invalid File Type!");
          this.$refs.file.value = null;
          return false;
        }
        this.form.file = this.$refs.file.files[0];
      }else{
        this.$toast.error("Transaction Completion must equal Total Outstanding Balance");
        this.$refs.file.value = null;
      }
    }

  }

};
</script>

<style scoped>
.document-upload h3 {
  color: red;
}

.pt-20 {
  padding-top: 20px;
}

.document-table {
  widows: 100%;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #000;
}

.edit-cell:focus {
  outline-color: transparent;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #fff;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #10b45a;
  border-color: #10b45a;
}

label.el-checkbox.is-disabled.is-checked>.el-checkbox__label {
  color: rgba(34, 42, 66, 0.7);
}

.btn-primary {
  background-color: #10b45a;
  color: #fff;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:hover {
  border-color: #10b45a;
  color: #fff;
  background-color: #10b45a;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:focus {
  color: #fff;
  outline-color: transparent;
}

.btn-secondary:focus {
  outline-color: transparent;
}

.btn-download {
  background-color: #344675;
  color: #ffffff;
}

.btn-secondary-dark:focus {
  outline-color: transparent;
}

.uploaded-document.not-uploaded {
  color: #606266;
}

/* 
.uploaded-document.uploaded {
  color: #10b45a;
} */
.uploaded-document.not-uploaded i {
  color: red;
  font-weight: 900;
  padding-right: 0.3em;
}

.uploaded-document.uploaded i {
  color: #10b45a;
  font-weight: 900;
  padding-right: 0.3em;
}

.divider-green {
  background-color: #10b45a;
}

.btn-secondary {
  background-color: #d3d7e9;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary:hover {
  background-color: #cccccc;
  color: #1d253b;
  border-color: #cccccc;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary-dark {
  background-color: #cccccc;
}

.btn-secondary-dark:hover {
  background-color: #d3d7e9;
  border: none;
  color: #1d253b;
}

.edit-cell {
  min-height: 35px;
  cursor: pointer;
}

.el-input__inner {
  border: 1px solid #10b45a;
}


.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}

.add-more-right-margin {
  margin-right: 12px;
}

.ratification-delete-btn {
  background-color: #275D34 !important;
  border-color: #275D34 !important;
}

.ratification-delete-btn:hover {
  background-color: #1e4428 !important;
  border-color: #1e4428 !important;
}
</style>
